import React from 'react'

import { Dot, Dots, CarouselDotsBase, Container } from './styles'

interface ICarouselDots {
  current?: number
  dots: any[]
  className?: string
}

const CarouselDots = ({ dots = [], current = 0, className = 'carousel-dots' }: ICarouselDots) => {
  if (dots.length === 0 || dots.length === 1) {
    return null
  }

  return (
    <CarouselDotsBase className={className}>
      <Container>
        <Dots data-testid="carousel-dots" current={current} total={dots.length}>
          {dots.map((item, index) => {
            const key = `${item}${index}`
            return <Dot data-testid="carousel-dot" key={key} selected={index === current} />
          })}
        </Dots>
      </Container>
    </CarouselDotsBase>
  )
}

export default CarouselDots
